import { defineComponent, onMounted, PropType, ref } from 'vue';
import { ApprovementForm } from '@/store/project/project.model';
import ApprovementFormComponent from '@/components/project/create/createComponents/approvementForm/ApprovementForm.vue';

export default defineComponent({
  name: 'ApprovementTabComponent',
  components: {
    ApprovementFormComponent
  },
  emits: [
    'submit'
  ],
  props: {
    approvement: {
      type: Object as PropType<ApprovementForm>,
      required: true,
    }
  },
  setup: (_, context) => {
    const approvementForm = ref<InstanceType<typeof ApprovementFormComponent>>();

    onMounted(() => {
      approvementForm.value?.unsubmit();
    });

    const submitClick = () => {
      approvementForm.value?.submitForm();
    };

    const validated = (approvementData: ApprovementForm) => {
      context.emit('submit', approvementData);
    };

    return {
      approvementForm,
      submitClick,
      validated,
    };
  },
});
